module.exports = __webpack_public_path__ + "img/59.7.Chla.529c465f.png";